import * as React from "react";
import {
  DataGrid,
  GridColDef,
  GridValueGetterParams,
  GridToolbar,
} from "@mui/x-data-grid";

const columns: GridColDef[] = [
  { field: "id", headerName: "ID", width: 90 },
  {
    field: "position",
    headerName: "Posição",
    width: 100,
  },
  {
    field: "reference",
    headerName: "Código Interno",
    width: 80,
  },
  {
    field: "description",
    headerName: "Descrição",
    width: 500,
  },
  {
    field: "ean",
    headerName: "EAN",
    width: 130,
  },
  {
    field: "amount",
    headerName: "Quantidade",
    width: 190,
    valueGetter: (params: GridValueGetterParams) =>
      `${(params.row.amount / (params.row.packageAmount || 1)).toFixed(
        2
      )} ( ${Number(params.row.amount).toFixed(2)} ${params.row.unit})`,
  },
  {
    field: "batch",
    headerName: "Lote",
    width: 110,
  },
];

export type PositionTableRow = {
  id: string;
  position: string;
  reference: string;
  description: string;
  ean: string;
  amount: string;
  batch: string;
  packageAmount: number;
  unit: string;
};

type Props = {
  data: PositionTableRow[];
};

export default function PositionsTable({ data }: Props) {
  return (
    <div style={{ width: "100%" }}>
      <DataGrid
        rows={data}
        columns={columns}
        slots={{
          toolbar: GridToolbar,
        }}
        initialState={{
          columns: {
            columnVisibilityModel: {
              id: false,
            },
          },
        }}
      />
    </div>
  );
}
